<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title *ngIf="title">
            {{ title }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="dismiss()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="data; else NoContent" padding class="content">
    <ion-label class="concept-description ion-text-center ion-text-wrap" lines="none" color="primary">
        {{ data }}
    </ion-label>
</ion-content>
<ng-template #NoContent>
    <ion-content class="content ion-padding">
        <ion-label class="concept-description ion-text-center ion-text-wrap" lines="none" color="primary">
            {{'Generic.noReportDescription' }}
        </ion-label>
    </ion-content>
</ng-template>
